/**
 * Imperative handle exposed by the editable contact lists. The parent modal
 * holds a ref to each list and calls {@link ContactListHandle.flushPendingEdits}
 * when its Save button is pressed, so staged row value edits are persisted
 * together with the rest of the form.
 *
 * Immediate actions (add / delete / make-primary) are NOT part of the flush —
 * they hit the backend the moment they're triggered.
 */
export interface ContactListHandle {
  /**
   * Persist every dirty, valid row value edit via the contact update endpoint.
   * Resolves once all edits have settled (per-row failures surface as their own
   * toasts and never reject this call). Returns the number of edits that failed
   * so the caller can avoid firing a contradictory "saved successfully" toast
   * when an edit was rejected (e.g. the value collides with another contact).
   */
  flushPendingEdits: () => Promise<number>;
}
